<template>
  <v-card class="sticky-bar py-2" :class="{'dense': dense, 'mb-6': !dense }" :outlined="outlined" flat>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
/**
 * A sticky bar layout component that remains at the top of the viewport when scrolling.
 * Typically used for headers or navigation elements that should always be accessible.
 * Includes a semi-transparent background with a blur effect to enhance readability.
 * Respects global navigation by default
 *
 * @example
 * Usage:
 * <sticky-bar>
 *  <!-- Content to be displayed in the sticky bar -->
 * </sticky-bar>
 */

export default {
  name: 'StickyBar',

  props: {
    /**
     * If true, applies a denser padding style to the sticky bar (v-card-text).
     */
    dense: {
      type: Boolean,
      default: false,
    },

    /**
     * If true, applies an outlined style to the sticky bar.
     */
    outlined: {
      type: Boolean,
      default: true,
    },
  }
};
</script>

<style lang="scss" scoped>
.sticky-bar {
  position: sticky;
  background-color: rgba(255, 255, 255, 0.7);
  top: var(--global-nav-height, 48px);
  z-index: 1;
  backdrop-filter: blur(10px);

  @media (max-width: 960px) {
    position: static;
  }

  &.dense :deep(.v-card__text) {
    padding: 6px 12px;
  }
}
</style>
